import React, { useState } from "react";
import { Popover, Typography } from "antd";
import "../../generic/filters/filterwrappercomponent.css";
import "../servicesettings/servicessettings.css";
import "./carecirclecomponent.css";
import PatientCareCircleComponent from "../../careprovider/visits/visitdetails/components/patientcarecirclecomponent/PatientCareCircleComponent";
import AddEditTeamMemberModalComponent from "./addedit/AddEditTeamMemberModalComponent";
import { useGetRole } from "../../generic/hooks/useGetRole";
import SmartIcon from "../../../components/generic/genericIcon/SmartIcon";
import SectionCard from "../../generic/sectioncard/SectionCard";
import ExistingCareCircleMemberModal from "./addedit/ExistingCareCircleMemberModal";

const CareCircleComponent = ({ userDetails, identifier }) => {
  const role = useGetRole();
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [existingMembers, setExistingMembers] = useState([]);

  const openModal = (option) => {
    setSelectedOption(option);
    setModalVisible(true);
  };

  const content = (
    <div className="services-popover-content">
      <Typography
        className="services-popover-button"
        onClick={() => openModal("Add New Member")}
      >
        Add New Member
      </Typography>
      <Typography
        className="services-popover-button"
        onClick={() => openModal("Add Existing Member")}
      >
        Add Existing Member
      </Typography>
    </div>
  );

  return (
    <SectionCard
      title={"Care Circle"}
      className="listCardStylingThirdRow"
      action={
        <Popover placement="bottom" content={content} showArrow={false}>
          {role === "Volunteer Coordinator" && (
            <div className="filter-select-btn">
              <SmartIcon iconKey={"settings"} />
            </div>
          )}
        </Popover>
      }
    >
      <div className="care-circle-container">
        {identifier && (
          <PatientCareCircleComponent
            identifier={identifier}
            showOnProfilePage={true}
            setExistingMembers={setExistingMembers}
          />
        )}
      </div>

      {isModalVisible && selectedOption === "Add New Member" && (
        <AddEditTeamMemberModalComponent
          isModalOpen={isModalVisible}
          setIsModalOpen={setModalVisible}
        />
      )}

      {isModalVisible && selectedOption === "Add Existing Member" && (
        <ExistingCareCircleMemberModal
          isModalOpen={isModalVisible}
          setIsModalOpen={setModalVisible}
          existingMembers={existingMembers}
        />
      )}
    </SectionCard>
  );
};

export default CareCircleComponent;
